import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatComponent } from './stat.component';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
		TranslateModule,
		RouterModule
    ],
    declarations: [StatComponent],
    exports: [StatComponent]
})
export class StatModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/stat/stat.module.ts